export default {
  path: '/design_files',
  name: 'design_files',
  component: () => import('../components/designfile/Layout'),
  redirect: { name: 'DesignFileList' },
  meta: {
    breadcrumb: 'designfile.designfiles',
  },
  children: [
    {
      name: 'DesignFileList',
      path: '',
      component: () => import('../views/designfile/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'DesignFileCreate',
      path: 'new',
      component: () => import('../views/designfile/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'DesignFileUpdate',
      path: ':id/edit',
      component: () => import('../views/designfile/Update'),
      meta: {
        breadcrumb: 'designfile.designfile',
      },
    },
    {
      name: 'DesignFileCatalog',
      path: 'catalog',
      component: () => import('../views/designfile/Catalog'),
      meta: {
        breadcrumb: 'designfile.catalog',
      },
    },
    {
      name: 'DesignFileShow',
      path: ':id',
      component: () => import('../views/designfile/Show'),
      meta: {
        breadcrumb: 'designfile.designfile',
      },
    },
  ]
};
